(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector("html").getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";

		if (dir === "rtl") {
			[nextEl, prevEl] = [prevEl, nextEl];
		}

		sliders.forEach((slider) => {
			if (slider?.swiper) return;

			new Swiper(slider, {
				pagination: {
					el: slider.querySelector(".product-pagination .swiper-pagination"),
					clickable: true,
				},
				navigation: {
					nextEl: slider.querySelector(".product-button-group .swiper-button-next"),
					prevEl: slider.querySelector(".product-button-group .swiper-button-prev"),
				},
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					},
				},
			});
		});
	};

	initSlider();
	globalThis.loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", initSlider);

	const grid = document.querySelector(".products-grid-section");
	if (grid) {
		const observer = new MutationObserver(initSlider);
		observer.observe(grid, {
			childList: true,
			subtree: true,
		});
	}
})();